module.exports = __webpack_public_path__ + "img/hero.b3d8a9c5.jpg";